import Checkbox from './Checkbox';
import forwardRef from '../utils/forwardRef';
export default forwardRef({
  name: 'Checkbox',
  ClassComponent: Checkbox
});